module.exports = __webpack_public_path__ + "static/flux-ux-audit-f15b19b5e30e45c0ec697bd67edb427b.jpg";